export const instrumentsMessages = {
  saveSuccess: 'The instrument was updated successfully.',
  publishSuccess: 'The instrument was published successfully.',
  publishError: 'Can not publish this template as not all required tags are provided!',
  exportSuccess: 'The export was generated successfully.',
  exportError: 'Unknown error occurred.',
};
